import Component from '../../components/Component';
import { withTranslation } from 'react-i18next';
import { getUpgradeUrl } from '../../helpers/upgradeUrl';

class StepsAnalytics extends Component {
    constructor() {
        super();

        this.getPermissions = this.getPermissions.bind(this);

        const iShowDiscoverAnalytics = window?.user_permissions?.discover_analytics;
        const iShowSearchAnalytics = window?.user_permissions?.search_analytics;
        const iShowAITracking = window?.user_permissions?.ai_tracking;
        const iShowCommerceAnalytics = window?.user_permissions?.commerce_analytics;
        const isTrial = window?.user_permissions?.subscription_status === 'trialing';

        this.state = {
            iShowDiscoverAnalytics,
            iShowSearchAnalytics,
            iShowAITracking,
            iShowCommerceAnalytics,
            isTrial,
        };
    }

    async componentDidMount() {
        document.addEventListener('getPermissionsEvent', this.getPermissions);
    }

    componentWillUnmount() {
        document.removeEventListener('getPermissionsEvent', this.getPermissions);
    }

    getPermissions() {
        const data = window?.user_permissions ? { ...window?.user_permissions } : {};
        this.setState({
            iShowDiscoverAnalytics: data?.discover_analytics,
            iShowSearchAnalytics: data?.search_analytics,
            iShowAITracking: data?.ai_tracking,
            iShowCommerceAnalytics: data?.commerce_analytics,
            isTrial: data?.subscription_status === 'trialing',
        });
    }

    render() {
        const { t } = this.props;
        const {
            iShowDiscoverAnalytics,
            iShowSearchAnalytics,
            iShowAITracking,
            iShowCommerceAnalytics,
            isTrial,
        } = this.state;

        return (
            <>
                <div className="google-discover-steps">
                    <div className="google-discover-steps-header">
                        {t('page_all_domain.analytics_box.header')}
                    </div>
                    <div className="google-discover-steps-body overview-page-steps">
                        <div className="google-discover-steps-body-item">
                            <div className="google-discover-steps-body-item-header">
                                <div className="google-discover-steps-body-item-header-img">
                                    <img
                                        src="/static/img/n_author-performance.svg"
                                        loading="lazy"
                                        alt="img"
                                    />
                                </div>
                                <a
                                    target="_blank"
                                    href={
                                        iShowDiscoverAnalytics
                                            ? `${this.props.url}/`
                                            : getUpgradeUrl('/domains/inactive-subscription?excluded=discover_analytics')
                                    }
                                    rel="noreferrer"
                                >
                                    <strong className="d-flex align-items-center gap-12">
                                        {' '}
                                        {t(
                                            'page_all_domain.analytics_box.google_discover_analytics_header',
                                        )}
                                        <i className="icon-arrow-right1" />
                                    </strong>
                                    <div
                                        className={`google-discover-steps-body-item-header-status ${
                                            iShowDiscoverAnalytics ? 'included' : 'not-included'
                                        }`}
                                    >
                                        {iShowDiscoverAnalytics
                                            ? t('global.included')
                                            : t('global.not_included')}
                                    </div>
                                </a>
                            </div>
                            <div className="google-discover-steps-body-item-body">
                                {t('page_all_domain.analytics_box.google_discover_analytics_body')}
                            </div>
                        </div>
                        <div className="google-discover-steps-body-item">
                            <div className="google-discover-steps-body-item-header">
                                <div className="google-discover-steps-body-item-header-img">
                                    <img
                                        src="/static/img/google-icon.png"
                                        loading="lazy"
                                        alt="img"
                                    />
                                </div>
                                <a
                                    target="_blank"
                                    href={
                                        iShowSearchAnalytics
                                            ? `${this.props.url}/gsc-reports/`
                                            : getUpgradeUrl('/domains/inactive-subscription?excluded=search_analytics')
                                    }
                                    rel="noreferrer"
                                >
                                    <strong className="d-flex align-items-center gap-12">
                                        {t(
                                            'page_all_domain.analytics_box.google_search_analytics_header',
                                        )}
                                        <i className="icon-arrow-right1" />
                                    </strong>
                                    <div
                                        className={`google-discover-steps-body-item-header-status ${
                                            iShowSearchAnalytics && !isTrial
                                                ? 'included'
                                                : 'not-included'
                                        }`}
                                    >
                                        {iShowSearchAnalytics
                                            ? isTrial
                                                ? t('global.not_included_in_trial')
                                                : t('global.included')
                                            : t('global.not_included')}
                                    </div>
                                </a>
                            </div>
                            <div className="google-discover-steps-body-item-body">
                                {t('page_all_domain.analytics_box.google_search_analytics_body')}
                            </div>
                        </div>
                        <div className="google-discover-steps-body-item">
                            <div className="google-discover-steps-body-item-header">
                                <div className="google-discover-steps-body-item-header-img">
                                    <img src="/static/img/ai_icon.svg" loading="lazy" alt="img" />
                                </div>
                                <a
                                    target="_blank"
                                    href={
                                        iShowAITracking
                                            ? '/ai-tracking'
                                            : getUpgradeUrl('/domains/inactive-subscription?excluded=ai_tracking')
                                    }
                                    rel="noreferrer"
                                >
                                    <strong className="d-flex align-items-center gap-12">
                                        {t('page_all_domain.analytics_box.ai_tracking_header')}{' '}
                                        <i className="icon-arrow-right1" />
                                    </strong>
                                    <div
                                        className={`google-discover-steps-body-item-header-status ${
                                            iShowAITracking ? 'included' : 'not-included'
                                        }`}
                                    >
                                        {iShowAITracking
                                            ? t('global.included')
                                            : t('global.not_included')}
                                    </div>
                                </a>
                            </div>
                            <div className="google-discover-steps-body-item-body">
                                {t('page_all_domain.analytics_box.ai_tracking_body')}
                            </div>
                        </div>
                        <div className="google-discover-steps-body-item">
                            <div className="google-discover-steps-body-item-header">
                                <div className="google-discover-steps-body-item-header-img">
                                    <img
                                        src="/static/img/google_icon_2.svg"
                                        loading="lazy"
                                        alt="img"
                                    />
                                </div>
                                <a
                                    target="_blank"
                                    href={
                                        iShowCommerceAnalytics
                                            ? '/commerce-analytics'
                                            : getUpgradeUrl('/domains/inactive-subscription?excluded=commerce')
                                    }
                                    rel="noreferrer"
                                >
                                    <strong className="d-flex align-items-center gap-12">
                                        {t(
                                            'page_all_domain.analytics_box.commerce_analytics_header',
                                        )}
                                        <i className="icon-arrow-right1" />
                                    </strong>
                                    <div
                                        className={`google-discover-steps-body-item-header-status ${
                                            iShowCommerceAnalytics ? 'included' : 'not-included'
                                        }`}
                                    >
                                        {iShowCommerceAnalytics
                                            ? t('global.included')
                                            : t('global.not_included')}
                                    </div>
                                </a>
                            </div>
                            <div className="google-discover-steps-body-item-body">
                                {t('page_all_domain.analytics_box.commerce_analytics_body')}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default withTranslation()(StepsAnalytics);
